var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-list',{ref:"log",attrs:{"config":"store/mall/log.js"},on:{"search":_vm.searchData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }